import React from 'react';
import { motion } from 'framer-motion';
interface CircuitGridProps {
  className?: string;
  rows?: number;
  cols?: number;
}
export function CircuitGrid({
  className = '',
  rows = 5,
  cols = 8
}: CircuitGridProps) {
  const pulses = Array.from({
    length: 14
  }).map((_, i) => {
    const horizontal = i % 2 === 0;
    const track = Math.floor(Math.random() * (horizontal ? rows : cols));
    const dur = 3 + Math.random() * 4;
    const delay = Math.random() * 3;
    const reverse = Math.random() > 0.5;
    return {
      horizontal,
      track,
      dur,
      delay,
      reverse,
      i
    };
  });
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-201">
      {Array.from({
      length: rows
    }).map((_, r) => <div key={`h-${r}`} className="absolute left-0 right-0 h-px bg-[#1a8fd4]/15" style={{
      top: `${(r + 1) / (rows + 1) * 100}%`
    }} data-id="element-202" />)}

      {Array.from({
      length: cols
    }).map((_, c) => <div key={`v-${c}`} className="absolute top-0 bottom-0 w-px bg-[#1a8fd4]/15" style={{
      left: `${(c + 1) / (cols + 1) * 100}%`
    }} data-id="element-203" />)}

      {pulses.map(p => <motion.div key={p.i} className="absolute" style={p.horizontal ? {
      top: `${(p.track + 1) / (rows + 1) * 100}%`,
      left: 0,
      right: 0,
      height: 1,
      marginTop: -0.5
    } : {
      left: `${(p.track + 1) / (cols + 1) * 100}%`,
      top: 0,
      bottom: 0,
      width: 1,
      marginLeft: -0.5
    }} data-id="element-204">
          <motion.div className="absolute" style={p.horizontal ? {
        top: -2,
        width: 80,
        height: 5,
        background: 'linear-gradient(90deg, transparent, rgba(26,143,212,0.9), transparent)',
        filter: 'blur(0.5px)',
        boxShadow: '0 0 12px rgba(26,143,212,0.8)'
      } : {
        left: -2,
        width: 5,
        height: 80,
        background: 'linear-gradient(180deg, transparent, rgba(26,143,212,0.9), transparent)',
        filter: 'blur(0.5px)',
        boxShadow: '0 0 12px rgba(26,143,212,0.8)'
      }} initial={p.horizontal ? {
        x: '-100%'
      } : {
        y: '-100%'
      }} animate={p.horizontal ? {
        x: p.reverse ? ['-100%', '100vw'] : ['100vw', '-100%']
      } : {
        y: p.reverse ? ['-100%', '100vh'] : ['100vh', '-100%']
      }} transition={{
        duration: p.dur,
        repeat: Infinity,
        delay: p.delay,
        ease: 'linear'
      }} data-id="element-205" />
        </motion.div>)}

      {Array.from({
      length: rows
    }).map((_, r) => Array.from({
      length: cols
    }).map((_, c) => <div key={`node-${r}-${c}`} className="absolute w-1 h-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1a8fd4]/30" style={{
      top: `${(r + 1) / (rows + 1) * 100}%`,
      left: `${(c + 1) / (cols + 1) * 100}%`
    }} data-id="element-206" />))}
    </div>;
}